/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsSbomBuildDifferenceResponse {
    getFixupPrototypeFunction() { return AppSecopsSbomBuildDifferenceResponse.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsSbomBuildDifferenceResponse>): AppSecopsSbomBuildDifferenceResponse {
        let obj = Object.assign(new AppSecopsSbomBuildDifferenceResponse(), model);
        AppSecopsSbomBuildDifferenceResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsSbomBuildDifferenceResponse>): AppSecopsSbomBuildDifferenceResponse {
        if (!model) return null;
        return AppSecopsSbomBuildDifferenceResponse.newInstance(<AppSecopsSbomBuildDifferenceResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsSbomBuildDifferenceResponse) {
        if (!obj) return;

        models.AppSecopsSbomBuildDifferenceResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsSbomBuildDifferenceResponse): boolean {
        Object.setPrototypeOf(obj, AppSecopsSbomBuildDifferenceResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.sbom_generated_date === "string") {
            this.sbom_generated_date = new Date(<string><any>this.sbom_generated_date);
        }
        if (this.new_vulnerabilities) {
            for (let val of this.new_vulnerabilities) {
                models.AppSecopsVulnerabilityWithComponentDetails.fixupPrototype(val);
            }
        }
    }

    /**
     * Unique ID of the build
     */
    build_id: string;

    /**
     * Unique ID of the latest SBOM build version
     */
    version_id: string;

    /**
     * Unique ID of the previous SBOM build version
     */
    compared_version_id: string;

    /**
     * SBOM file generated datetime
     */
    sbom_generated_date: Date;

    /**
     * List of new component IDs created in the build
     */
    new_components: Array<string>;

    /**
     * List of upgraded component IDs in the build
     */
    upgraded_components: Array<string>;

    /**
     * List of deleted component IDs in the build
     */
    deleted_components: Array<string>;

    /**
     * List of new vulnerability and component details
     */
    new_vulnerabilities: Array<models.AppSecopsVulnerabilityWithComponentDetails>;

    /**
     * List of resolved vulnerability unique IDs in the build
     */
    resolved_vulnerabilities: Array<string>;

}
